import { getDataWithQueryString } from "./componentAPIs";

const TIMEOUT =3000;

const getDataWithAbort = (() => {
  // Keep track of the last completed request for each URL and query string
  const lastInitializedRequest = {};

  // Keep a map of abort controllers for each URL and query string to be able to cancel stale requests
  const requestMap = new Map();

  // Return a function that takes the URL, query string and configuration as parameters
  return (url, queryString = "", config = {}) => {
    // Create a key for the URL and query string
    const key = `${url}:${queryString}`;
    // Get the abort controller for this URL and query string, if there is one
    const source = requestMap.get(key);
    let isAborted = false;

    // If there is a controller for this URL and query string, check if the last request completed within the last 5 seconds
    if (source && lastInitializedRequest[key]) {
      const timeElapsed = Date.now() - lastInitializedRequest[key];
      if (timeElapsed < TIMEOUT) {
        // If the last request intialized less than 5 seconds ago, abort the previous request
        source.abort(`Request cancelled: previous request for ${key} is stale`);
        isAborted = true;
      }
    } 

    // Create a new AbortController for this request
    const controller = new AbortController();
    const signal = controller.signal;

    // Add the new controller to the requestMap
    requestMap.set(key, controller);

    // Send the request using axios and return a Promise that resolves to the response data
    const promise = new Promise((resolve, reject) => {
      // Store the timestamp of the latest intitialized request for this URL and query string
      if (!lastInitializedRequest[key]) {
        lastInitializedRequest[key] = Date.now() - TIMEOUT; // allows first request to always succeed
      } else if (!isAborted) {
        lastInitializedRequest[key] = Date.now();
      }
      getDataWithQueryString(url, queryString, { signal })
        .then((response) => {
          // Resolve the Promise with the response data
          if (response.message === "canceled") {
            reject(response);
          }
          resolve(response);
        })
        .catch((error) => {
          // Reject the Promise with the error
          reject(error);
        });
    });

    // Return the Promise
    return promise;
  };
})();

export default getDataWithAbort;
